import React from 'react';
import Img from 'gatsby-image';
import style from './pressHeader.module.css';

const PressHeader = ({ section }) => {
  
  return (
    <main className={style.headerWrapper}>
      <section className={style.headerContainer}>
        <div>
          <h2>{section.title}</h2>
          <p>{section.body1}</p>
        </div>
        <div>
          <Img fluid={section.images[0].fluid} alt={'App promo'} />
          
        </div>
      </section>
    </main>
  );
};
export default PressHeader;
